(ns kyber.kyber-db.question)

(def model
  {:ident-key
   :question/uuid

   :refs
   {:question.context/learning-objective
    {:model :learning-objective
     :cardinality :one}
    
    :question/subject-matter-object
    {:model :resource
     :cardinality :one}}

   :schema
   #:question
   {:uuid
    {:doc "UUID of the question"}}})
